import {View} from "react-native";
import {EventFollowRequest} from "@/lib/types";
import {useRouter} from "expo-router";
import {fetchBackendNoContent} from "@/lib/backend";
import {useSession} from "@/lib/auth/auth";
import {Color} from "@/lib/styles";
import ActionButton from "@/lib/components/ActionButton";
import {useState} from "react";
import {useEvent} from "@/lib/providers/EventProvider";

export default function EventHeader() {
    const {session} = useSession();
    const router = useRouter();

    const [busy, setBusy] = useState(false);

    const {event, refreshEvent} = useEvent();

    async function saveAttendance(request: EventFollowRequest) {
        if (!event) {
            return null;
        }
        setBusy(true);
        fetchBackendNoContent(`/event/${event.event_id}/attend`, "POST", session, request).then(async () => {
            refreshEvent();
            setBusy(false);
        }).catch((_error) => {
            // setSaveError(error);
        }).finally(() => {
            setBusy(false);
        });
    }

    if (!event) {
        return null;
    }

    return (
        <View style={{flexDirection: "row", gap: 6}}>
            {!!session && !event.permissions.edit && <ActionButton
                onPress={() => saveAttendance({follow: !event.is_following})}
                busy={busy}
                height={34}
                icon={"heart"}
                border={false}
                backgroundColor={event.is_following ? Color.Yellow : Color.Background}
                color={event.is_following ? Color.Background : Color.PrimaryText}
            />}
            {event.permissions.invite && <ActionButton
                onPress={() => router.push(`/e/${event.event_id}/share`)}
                height={34}
                border={false}
                icon={"share"}
            />}
            {event.permissions.edit && <ActionButton
                onPress={() => router.push(`/e/${event.event_id}/edit`)}
                height={34}
                border={false}
                icon={"edit"}
            />}
        </View>
    )
}